import classnames from 'classnames';
import Image from 'next/image';
import React from 'react';

import { loadAsset } from '@cineamo/ui/src/helpers/asset-helper';

const moviePlaceholderImage = loadAsset('/images/placeholders/portrait/im-posterFilmWithTitlePortrait.jpg');

/**
 * Pure presentational component for displaying a movie poster image.
 * Shows movie poster with fallback to placeholder if no image is available.
 * Displays movie title overlay when using placeholder.
 */
const MoviePosterImage: React.FC<{
    className?: string;
    // Optional: `MovieDto.title` is not guaranteed for every locale.
    movieTitle?: string;
    moviePosterImage?: string;
    moviePosterBlurDataImage?: string;
    width?: number;
    height?: number;
    showTitleOnPosterFallback?: boolean;
}> = ({
    className,
    movieTitle,
    moviePosterImage,
    moviePosterBlurDataImage,
    width = 200,
    height = 300,
    showTitleOnPosterFallback = true
}) => {
    return (
        <div className={classnames(className, 'block relative h-full flex-none')}>
            <Image
                className="w-full h-full object-cover"
                width={width}
                height={height}
                src={moviePosterImage || moviePlaceholderImage}
                placeholder={moviePosterBlurDataImage ? 'blur' : 'empty'}
                blurDataURL={moviePosterBlurDataImage ? moviePosterBlurDataImage : undefined}
                alt={`${movieTitle ?? ''} poster`}
            />

            {!moviePosterImage && showTitleOnPosterFallback && (
                <span
                    className="absolute bottom-0 w-full text-center text-body-bold-10 text-white p-6 break-words whitespace-pre-wrap
                    h-auto select-none truncate">
                    {movieTitle}
                </span>
            )}
        </div>
    );
};

export default MoviePosterImage;
